'use client';

import { useMemo } from 'react';

import Authentication from '@vv/auth-sdk';

import type { AuthInstance } from '@/types/auth-sdk';

export const isAuthAvailable = typeof window !== 'undefined';

export const useAuth = () => {
  const auth = useMemo<AuthInstance | null>(() => {
    if (!isAuthAvailable) return null;

    const win = window as Window & { __VV_AUTH_SDK__?: AuthInstance };
    // eslint-disable-next-line no-underscore-dangle -- SDK attaches to window.__VV_AUTH_SDK__
    return win.__VV_AUTH_SDK__ ?? (Authentication as AuthInstance);
  }, []);

  return auth;
};
